import React, { useState } from 'react';

import {
  Footer,
  Icon,
  Text,
  Title,
  Header,
} from 'components/ListingModal/styles';

import { Modal, Button, Form } from '@cloudez/cloudez-design-system';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faExclamationTriangle,
  faSpinner,
} from '@fortawesome/free-solid-svg-icons';

import { Content } from './styles';

interface RevokeModalProps {
  show: boolean;
  setShow: (value: boolean) => void;
  action: () => Promise<void>;
}

const RevokeModal: React.FC<RevokeModalProps> = ({ show, setShow, action }) => {
  const [loading, setLoading] = useState(false);

  const confirmRevoke = async () => {
    setLoading(true);
    await action();
    setLoading(false);
    setShow(false);
  };

  return (
    <Modal width="497px" show={show} setShow={setShow} noExit={loading}>
      <Header>
        <Icon>
          <FontAwesomeIcon icon={faExclamationTriangle} />
        </Icon>
        <Text>
          <Title>Deseja revogar seu token de API?</Title>
        </Text>
      </Header>

      <Form onSubmit={confirmRevoke}>
        <Content>
          <span>
            <b>Atenção!</b> O token atual deixa de funcionar imediatamente e um
            novo será gerado. Qualquer integração que use o token antigo
            precisará ser atualizada.
          </span>
        </Content>
        <Footer hasLink>
          <Button
            onClick={() => setShow(false)}
            type="button"
            outline
            disabled={loading}
          >
            Cancelar
          </Button>
          <Button error disabled={loading} type="submit">
            {loading ? (
              <FontAwesomeIcon
                style={{ marginLeft: '0' }}
                icon={faSpinner}
                spin
              />
            ) : (
              'Revogar'
            )}
          </Button>
        </Footer>
      </Form>
    </Modal>
  );
};

export default RevokeModal;
